import { render, staticRenderFns } from "./PasosCredito.vue?vue&type=template&id=474c75af&scoped=true"
import script from "./PasosCredito.vue?vue&type=script&setup=true&lang=js"
export * from "./PasosCredito.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PasosCredito.vue?vue&type=style&index=0&id=474c75af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c75af",
  null
  
)

export default component.exports